import { useMemo } from 'react';
import { getConfig } from '../common/config';
import { appCodeSelector, languageSelector } from '../store/form/selectors';
import { useAppSelector } from '../store/hooks';

export const useConfig = () => {
    const appCode = useAppSelector(appCodeSelector);
    const lang = useAppSelector(languageSelector);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const config = useMemo(() => getConfig(appCode), [appCode, lang]);
    return config;
};
